import { render, staticRenderFns } from "./goodsPriceChange.vue?vue&type=template&id=68d3afe1&scoped=true&"
import script from "./goodsPriceChange.vue?vue&type=script&lang=js&"
export * from "./goodsPriceChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3afe1",
  null
  
)

export default component.exports